/** FAQ, Support, and Advertising page copy (Swedish). */
export const pagesMessagesSv = {
  faq: {
    pageTitle: "Vanliga Frågor",
    pageSubtitle: "Hitta svar på vanliga frågor om WasOK",
    seoTitle: "Vanliga frågor — WasOK",
    seoDescription:
      "Svar på vanliga frågor om WasOK, produktskanning, integritet och betyg.",
    items: [
      {
        question: "Hur fungerar WasOK?",
        answer:
          "WasOK hjälper dig komma ihåg vilka produkter du gillade eller ogillade genom att skanna streckkoder och spara dina betyg och anteckningar. Skanna helt enkelt en produkts streckkod, betygsätt den, lägg till anteckningar, och nästa gång du skannar samma produkt ser du direkt din tidigare recension.",
      },
      {
        question: "Lagras mina data i molnet?",
        answer:
          "Nej! All din data lagras lokalt på din enhet. Vi synkroniserar inte din information till molnet, vilket innebär att din inköpshistorik och dina produktåsikter förblir helt privata. Detta innebär dock också att du bör säkerhetskopiera din enhet om du vill bevara dina data.",
      },
      {
        question: "Behöver jag internetanslutning för att använda WasOK?",
        answer:
          "Nej, WasOK fungerar helt offline. Eftersom all din data lagras lokalt på din enhet kan du skanna produkter, lägga till betyg och se din historik utan någon internetanslutning.",
      },
      {
        question: "Kan jag använda WasOK för alla typer av produkter?",
        answer:
          "Ja! WasOK fungerar med alla produkter som har en streckkod. Oavsett om det är mat, kosmetika, hushållsartiklar, elektronik eller något annat med en streckkod kan du skanna det och spara dina åsikter.",
      },
      {
        question: "Hur skannar jag en streckkod?",
        answer:
          "Öppna helt enkelt WasOK-appen och tryck på skanningsknappen. Rikta kameran mot produktens streckkod, så identifierar och skannar appen den automatiskt. Se till att streckkoden är väl belyst och i fokus för bästa resultat.",
      },
      {
        question: "Kan jag lägga till foton i mina produktrecensioner?",
        answer:
          "Ja! Du kan bifoga foton till alla produktrecensioner. Detta är särskilt användbart för att komma ihåg förpackningsdetaljer, ingredienslistor eller annan visuell information som kan hjälpa dig minnas varför du gillade eller ogillade en produkt.",
      },
      {
        question: "Vilken information kan jag spara om produkter?",
        answer:
          "Du kan spara betyg (1-5 stjärnor), textanteckningar, foton, priset du betalade, var du köpte den och egna kategorier. Denna omfattande information hjälper dig fatta välgrundade beslut när du handlar.",
      },
      {
        question: "Kan jag skapa inköpslistor?",
        answer:
          "Ja! WasOK låter dig skapa inköpslistor från produkter du redan har recenserat. Detta gör det enkelt att komma ihåg vilka produkter du älskade och vill köpa igen.",
      },
      {
        question: "Hur organiserar jag mina produkter?",
        answer:
          "Du kan organisera produkter med egna kategorier. Du kan till exempel skapa kategorier som 'Snacks', 'Kaffe', 'Hudvård' eller 'Rengöringsprodukter'. Detta gör det enkelt att bläddra bland dina recensioner efter typ.",
      },
      {
        question: "Är WasOK gratis att använda?",
        answer:
          "Ja, WasOK är helt gratis att ladda ner och använda. Det finns inga köp i appen, prenumerationer eller dolda avgifter. Vi tror att alla ska ha tillgång till ett privat sätt att komma ihåg sina produktpreferenser.",
      },
      {
        question: "Är WasOK tillgänglighetsanpassad?",
        answer:
          "WasOK är utformad för att kunna användas av så många som möjligt. Appen innehåller tillgänglighetsfunktioner som skärmläsarstöd, skalbar text och ett valfritt högkontrastläge.",
      },
      {
        question: "Vad händer om jag avinstallerar appen?",
        answer:
          "Eftersom all data lagras lokalt på din enhet kommer avinstallation av appen att radera alla dina produktrecensioner, anteckningar och inköpslistor. Se till att exportera dina data om du vill behålla en säkerhetskopia innan du avinstallerar.",
      },
      {
        question: "Kan jag exportera mina data?",
        answer:
          "Ja, WasOK låter dig exportera dina data för säkerhetskopiering. Du kan exportera alla dina recensioner till en fil som du kan spara på din enhet eller den molnlagring du väljer.",
      },
      {
        question: "Spårar WasOK min plats?",
        answer:
          "Nej, WasOK spårar inte din plats. Även om du manuellt kan ange namnet på butiken där du köpte en produkt, använder appen inte GPS eller platstjänster.",
      },
      {
        question: "Kan jag använda WasOK på flera enheter?",
        answer:
          "För närvarande synkroniserar inte WasOK mellan enheter eftersom all data lagras lokalt. Varje enhet har sin egen separata databas med produkter och recensioner.",
      },
      {
        question: "Vad händer om en streckkod inte går att skanna?",
        answer:
          "Om en streckkod inte går att skanna, se till att den är väl belyst och i fokus. Du kan också prova att rengöra kameralinsen. Om streckkoden är skadad eller otydlig kan du ha möjlighet att ange streckkodsnumret manuellt.",
      },
    ],
    cta: {
      heading: "Har du fortfarande frågor?",
      body: "Kontakta vårt supportteam — vi hjälper gärna till.",
      button: "Kontakta support",
    },
  },
  support: {
    pageTitle: "Support",
    seoTitle: "Support — WasOK",
    seoDescription:
      "Få hjälp med WasOK: kontakta support, rapportera buggar och dela feedback.",
    getHelp: {
      title: "Få Hjälp",
      body: "Vi är här för att hjälpa dig få ut det mesta av WasOK. Om du upplever problem eller har frågor har vi flera resurser tillgängliga för att hjälpa dig.",
    },
    faq: {
      title: "Vanliga Frågor",
      body: "Innan du kontaktar oss, kolla vårt avsnitt med vanliga frågor där vi besvarar de vanligaste frågorna om WasOK. Där hittar du detaljerad information om hur appen fungerar, integritet, datalagring med mera.",
    },
    contact: {
      title: "Kontakta Support",
      body: "Om du inte hittar svaret du letar efter är vårt supportteam redo att hjälpa till. Du kan nå oss på:",
      emailLabel: "E-post:",
      responseTime: "Vi svarar normalt inom 24-48 timmar",
    },
    bugs: {
      title: "Rapportera Buggar",
      body: "Hittade du en bugg? Vi uppskattar din hjälp med att göra WasOK bättre. Vid rapportering av en bugg, vänligen inkludera:",
      items: [
        "En detaljerad beskrivning av problemet",
        "Steg för att återskapa problemet",
        "Din enhetsmodell och Android-version",
        "Skärmdumpar eller skärminspelningar om möjligt",
      ],
      sendPrefix: "Skicka buggrapporter till:",
    },
    featureRequests: {
      title: "Funktionsförfrågningar",
      bodyBefore: "Har du en idé för en ny funktion? Vi vill gärna höra från dig! Skicka dina förslag till",
      bodyAfter:
        ". Även om vi inte kan implementera varje begäran, överväger vi noggrant all feedback när vi planerar framtida uppdateringar.",
    },
    knownIssues: {
      title: "Kända Problem",
      body: "Vi är för närvarande medvetna om följande problem och arbetar på lösningar:",
      items: [
        "Vissa streckkoder kanske inte skannar i svag belysning — prova att använda en ficklampa",
        "Mycket långa produktanteckningar kan ta en stund att spara på äldre enheter",
        "Bildminiatyrer kan se pixliga ut på högupplösta skärmar",
      ],
    },
    appUpdates: {
      title: "Appuppdateringar",
      body: "Vi släpper regelbundet uppdateringar med nya funktioner, förbättringar och buggfixar. Se till att hålla WasOK uppdaterad via Google Play Store för att få de senaste förbättringarna.",
    },
    community: {
      title: "Gemenskap",
      body: "Gå med i vår gemenskap av användare som fattar smartare köpbeslut med WasOK. Dela tips, ställ frågor och få kontakt med andra användare på våra sociala kanaler.",
    },
    emergency: {
      title: "Akutsupport",
      body: 'Om du upplever ett kritiskt problem som hindrar dig från att använda appen, markera ditt e-postmeddelande som "URGENT" i ämnesraden, så prioriterar vi din förfrågan.',
    },
    cta: {
      heading: "Behöver du fortfarande hjälp?",
      body: "Vårt supportteam finns här för dig. Tveka inte att höra av dig med frågor eller funderingar.",
      button: "Maila support",
    },
  },
  advertising: {
    pageTitle: "Annonsering & Monetisering",
    seoTitle: "Annonsering — WasOK",
    seoDescription: "Hur WasOK förhåller sig till annonsering och monetisering.",
    approach: {
      title: "Vårt Tillvägagångssätt",
      body: "På WasOK tror vi att dina köpvanor och produktåsikter är privata och personliga. Vår affärsmodell speglar detta grundläggande värde.",
    },
    noAds: {
      title: "Inga Annonser",
      body: "WasOK visar inga annonser. Vi kommer aldrig att visa dig annonser baserade på produkterna du skannar, betygen du ger eller någon annan data du skapar i appen. Din upplevelse med WasOK är helt annonsfri.",
    },
    noDataSelling: {
      title: "Ingen Datauthyrning",
      body: "Vi säljer, hyr ut eller delar inte din data med annonsörer, datamäklare eller några tredje parter. Eftersom all din data lagras lokalt på din enhet har vi inte ens tillgång till den. Dina produktrecensioner, inköpslistor och anteckningar tillhör bara dig.",
    },
    noTracking: {
      title: "Ingen Spårning",
      body: "WasOK använder inte spårningspixlar, analystjänster eller annan teknik som övervakar ditt beteende eller delar information med tredje part. Vi spårar inte vilka produkter du skannar, vilka butiker du handlar i, eller hur du använder appen.",
    },
    sustainability: {
      title: "Hur Vi Förblir Hållbara",
      body: "Du kanske undrar hur vi håller WasOK gratis utan annonser eller datauthyrning. Vårt tillvägagångssätt är enkelt:",
      items: [
        {
          label: "Gratis och Öppet:",
          text: "WasOK är gratis för alla att använda, utan premiumnivåer eller betalväggar",
        },
        {
          label: "Slimmad Drift:",
          text: "Vi håller våra kostnader låga genom att bygga effektiv, integritetsfokuserad programvara",
        },
        {
          label: "Frivilliga Donationer:",
          text: "Användare som älskar WasOK kan stödja oss genom frivilliga donationer",
        },
        {
          label: "Öppen Källkod:",
          text: "Vi kan erbjuda konsult- eller anpassade utvecklingstjänster för organisationer",
        },
      ],
    },
    noAffiliate: {
      title: "Inga Affiliatelänkar",
      body: "WasOK använder inte affiliatelänkar eller får provisioner från återförsäljare. När du skannar en produkt omdirigerar vi dig inte till att köpa den någonstans. Appen är enbart till för din personliga registerhållning och beslutsfattande.",
    },
    noPromotions: {
      title: "Inga Produktkampanjer",
      body: "Vi accepterar inte betalning från varumärken eller tillverkare för att marknadsföra deras produkter. WasOK kommer aldrig att föreslå produkter, lyfta fram vissa varumärken eller påverka dina betyg på något sätt. Dina åsikter är dina egna.",
    },
    partnerships: {
      title: "Tredjepartssamarbeten",
      body: "WasOK samarbetar inte med marknadsföringsföretag, dataaggregatorer eller annonsnätverk. Vi verkar självständigt och prioriterar din integritet framför allt annat.",
    },
    future: {
      title: "Framtidsplaner",
      body: "Vi är engagerade i att hålla WasOK annonsfritt och integritetsfokuserat. Om vi någonsin skulle behöva introducera en hållbar affärsmodell i framtiden kommer vi att:",
      items: [
        "Meddela alla ändringar i god tid i förväg",
        "Aldrig kompromissa om integritet eller datasäkerhet",
        "Alltid erbjuda ett sätt att använda appen utan spårning eller annonser",
        "Lyssna på användarfeedback och funderingar",
      ],
    },
    supporting: {
      title: "Stödja WasOK",
      body: "Om du älskar WasOK och vill stödja vårt uppdrag om integritetsfokuserat köpminne kan du:",
      items: [
        "Berätta för dina vänner och familj om appen",
        "Lämna en positiv recension i Google Play Store",
        "Dela din feedback och dina förslag med oss",
        "Överväga att göra en frivillig donation (när det är tillgängligt)",
      ],
    },
    cta: {
      heading: "Frågor om våra policyer?",
      body: "Vi är transparenta med hur WasOK fungerar. Om du har frågor om vårt tillvägagångssätt gällande integritet, monetisering eller hållbarhet, vänligen hör av dig.",
      button: "Kontakta Oss",
    },
  },
};
